import { mediaGalleryStyles as s } from "./MediaGallery.styles";
import type { MediaGalleryData, MediaItemData } from "./MediaGallery.types";
import { isAllowedMediaUrl } from "./mediaUrlAllowlist";

function isMediaItem(value: unknown): value is MediaItemData {
  if (typeof value !== "object" || value === null) {
    return false;
  }
  const item = value as Record<string, unknown>;
  return (item.kind === "embed" || item.kind === "image") && typeof item.url === "string";
}

export function MediaGallery({ items }: MediaGalleryData) {
  const validItems = (Array.isArray(items) ? items : [])
    .filter(isMediaItem)
    .filter((item) => isAllowedMediaUrl(item.url));

  if (validItems.length === 0) {
    return null;
  }

  return (
    <div className={s.grid}>
      {validItems.map((item, index) => (
        <MediaItem key={`${item.kind}-${item.url}-${index}`} item={item} />
      ))}
    </div>
  );
}

function MediaItem({ item }: { item: MediaItemData }) {
  return (
    <div className={s.item}>
      {item.kind === "embed" ? (
        <div className={s.embedWrapper}>
          <iframe
            className={s.embedFrame}
            src={item.url}
            title={item.description ?? "Embedded media"}
            sandbox="allow-scripts allow-same-origin allow-presentation"
            referrerPolicy="no-referrer"
            loading="lazy"
          />
        </div>
      ) : (
        <img
          className={s.image}
          src={item.url}
          alt={item.description ?? ""}
          referrerPolicy="no-referrer"
          loading="lazy"
        />
      )}
      {item.description && <p className={s.caption}>{item.description}</p>}
    </div>
  );
}
